import { useState, type FormEvent } from 'react'
import Logo from '../ui/Logo'
import { useAuth } from '../auth/AuthContext'

export default function Connexion() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [voir, setVoir] = useState(false)
  const [erreur, setErreur] = useState<string | null>(null)
  const [envoi, setEnvoi] = useState(false)

  const valider = async (e: FormEvent) => {
    e.preventDefault()
    setErreur(null)
    setEnvoi(true)
    const msg = await signIn(email, password)
    setEnvoi(false)
    if (msg) setErreur(msg)
  }

  return (
    <div className="min-h-screen bg-[#F6F6F7] flex items-center justify-center px-4 font-baloo text-kdp-dark">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <Logo className="w-28 text-kdp-red" />
          <h1 className="mt-4 text-2xl font-bold">KD Peinture — ERP</h1>
          <p className="text-sm text-[#6B6B6B]">La qualité fait la différence</p>
        </div>

        <form onSubmit={valider} className="bg-white border border-[#E7E7E7] rounded-2xl p-6 space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-semibold mb-1">E-mail</label>
            <input
              id="email" type="email" autoComplete="username" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#D9D9D9] rounded-xl px-3 py-2 outline-none focus:border-kdp-blue focus:ring-4 focus:ring-[#EAF1FF]"
            />
          </div>
          <div>
            <label htmlFor="mdp" className="block text-sm font-semibold mb-1">Mot de passe</label>
            <div className="relative">
              <input
                id="mdp" type={voir ? 'text' : 'password'} autoComplete="current-password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-[#D9D9D9] rounded-xl px-3 py-2 pr-20 outline-none focus:border-kdp-blue focus:ring-4 focus:ring-[#EAF1FF]"
              />
              <button type="button" onClick={() => setVoir(!voir)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-kdp-blue font-semibold px-2">
                {voir ? 'Cacher' : 'Afficher'}
              </button>
            </div>
          </div>
          {erreur && <p role="alert" className="text-sm font-semibold text-kdp-red bg-[#FDECEE] rounded-lg px-3 py-2">{erreur}</p>}
          <button type="submit" disabled={envoi}
            className="w-full bg-kdp-red text-white font-semibold rounded-xl py-2.5 disabled:opacity-60">
            {envoi ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  )
}
